const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';
import { apiFetch } from './interceptor';

export const overallBetLimitsApi = {
  getOverallBetLimits: async (token, page = 1, limit = 20) => {
    try {
      const url = `${BASE_URL}/overallBetLimits?page=${page}&limit=${limit}`;
      
      console.log('Requesting overall bet limits from:', url);
      
      const response = await apiFetch(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      // Check if we got a redirected response
      if (response && response.redirected) {
        return { redirected: true };
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error fetching overall bet limits:", error);
      throw error;
    }
  },

  createOverallBetLimit: async (token, limitData) => {
    try {
      const response = await apiFetch(`${BASE_URL}/overallBetLimits`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(limitData)
      });
      
      // Check if we got a redirected response
      if (response && response.redirected) {
        return { redirected: true };
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error creating overall bet limit:", error);
      throw error;
    }
  },

  deleteOverallBetLimit: async (token, id) => {
    try {
      const response = await apiFetch(`${BASE_URL}/overallBetLimits/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      // Check if we got a redirected response
      if (response && response.redirected) {
        return { redirected: true };
      }
      
      // Handle both cases: response with content or empty response
      if (response.status === 204) {
        return { success: true };
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error deleting overall bet limit:", error);
      throw error;
    }
  }
}; 